import type { SignalTypeFilter as SignalTypeFilterValue } from "../types";
import { SIGNAL_TYPE_FILTERS } from "../score";

/**
 * Redesign · filter row 1 (sealed mock). A boxed pill group for signal type.
 * The row is single-select, so it is a radiogroup of radios (not toggle
 * buttons): picking RFPs drops All, which aria-checked conveys correctly and
 * aria-pressed would not. Composes with the status row — the selected type is a
 * query param the feed adapter applies alongside the tab predicate (matches the
 * get_signal_feed signal_type argument).
 */
export function SignalTypeFilter({
  active,
  onChange,
}: {
  active: SignalTypeFilterValue;
  onChange: (value: SignalTypeFilterValue) => void;
}): JSX.Element {
  return (
    <div className="sx-filters">
      <p className="sx-f-eyebrow">Signal type</p>
      <div className="sx-pill-row" role="radiogroup" aria-label="Signal type">
        {SIGNAL_TYPE_FILTERS.map((f) => (
          <button
            key={f.key}
            type="button"
            role="radio"
            aria-checked={active === f.key}
            className="sx-typepill"
            onClick={() => onChange(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
}
